module.exports = __webpack_public_path__ + "img/product-1-INTphone.3ad6c690.png";